import { createSelector } from 'reselect';

const scanNotesPermissions = (state, props) => state.scanNotesPermissions;

export const selectScanNotesPermissions = createSelector(
  [scanNotesPermissions],
  scanNotesPermissions => {
    return scanNotesPermissions;
  }
);

export const selectCanTakeNotes = createSelector(
  [scanNotesPermissions],
  scanNotesPermissions => {
    return scanNotesPermissions.can_take_notes || false;
  }
);
